import { GetDataUserMenuSuccessAction, IsResultAction, RequertUserMenuFailedAction } from "../actions";
import { Api } from "./api";
import { put, takeLatest } from "redux-saga/effects";
import { DELETE_DATA_USER_MENU, GET_DATA_USER_MENU, SET_DATA_USER_MENU } from "../actions/actionsTypes";

function* GetDataUserMenu()
{
    try {
        const DataUserMenu = yield Api.GetDataUserMenuFromApi();
        yield put(GetDataUserMenuSuccessAction(DataUserMenu));
    } catch (error) {
        yield put(RequertUserMenuFailedAction(error));
    }
}
export function* watchGetDataUserMenu(){
    yield takeLatest(GET_DATA_USER_MENU,GetDataUserMenu); 
}

function* DeleteDataUserMenu(action){
    try {
        const isResult = yield Api.DeleteDataUserMenuFromApi(action.ID);
        if (isResult) {
            yield put(IsResultAction(isResult));
        }
        else {
            yield put(RequertUserMenuFailedAction("error"));
        }
    } catch (error) {
        yield put(RequertUserMenuFailedAction(error));
    }
}
export function* watchDeleteDataUserMenu(){
    yield takeLatest(DELETE_DATA_USER_MENU,DeleteDataUserMenu);
}

function* SetDataUserMenu(action){
    try {
        const isResult = yield Api.SetDataUserMenuFromApi(action.DataUserMenu);
        if (isResult) {
            yield put(IsResultAction(isResult));
        }
        else {
            yield put(RequertUserMenuFailedAction("error"));
        }
    } catch (error) {
        yield put(RequertUserMenuFailedAction(error));
    }
}
export function* watchSetDataUserMenu(){
    yield takeLatest(SET_DATA_USER_MENU,SetDataUserMenu);
}